import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import Link from 'Icons/Link';

import './portfolio.scss';

const iframes = [
  { name: 'Czarna Owca Gastro Pub', src: '/storage/img/for-restaurants/iframe-czarna-owca.png', url: 'www.czarnaowcagastropub.pl' },
  { name: 'Panda Sushi Lublin', src: '/storage/img/for-restaurants/iframe-panda-sushi.png', url: 'www.pandasushi.lu' },
  { name: 'Oberża 86', src: '/storage/img/for-restaurants/iframe-oberza.png', url: 'https://www.oberza86.pl' }
];

const websites = [
  { name: 'Boru Ramen Shop', src: '/storage/img/for-restaurants/website-boru.png', url: 'https://boruramenshop.pl' },
  { name: 'Punkt Gastronomiczny', src: '/storage/img/for-restaurants/website-punkt-g-1.png', url: 'https://punkt-g-lublin.pl' },
  { name: 'Ministerstwo Barszczu', src: '/storage/img/for-restaurants/website-ministerstwo.png', url: 'https://ministerstwobarszczu.pl' },
];

const imgWrapperStyle = {
  border: '1px solid lightgray',
  borderRadius: 8,
  overflow: 'hidden',
}

const imgStyle = {
  maxWidth: '100%',
}

const WebsitePortfolio = () => {
  const [activePhoto, setActivePhoto] = useState(null);

  const renderPortfolioItem = item => <figure key={item.name} className="portfolio-item" style={imgWrapperStyle}>
    <img src={item.src} alt={`Moduł do zamówień online na stronie restauracji ${item.name}`} style={imgStyle} onClick={() => setActivePhoto(item)} />
    <figcaption className="mt-2">
      <a href={item.url} target="_blank" rel="noopener noreferrer"><Link /> {item.name}</a>
    </figcaption>
  </figure>;

  return <section className="portfolio">
    <h4 className="home-title home-title--smaller mb-3 w-100">Oni już sprzedają online na własnej stronie</h4>
    <h4 className="w-100 mb-3">Strony wwww dla restauracji, stworzone od zera</h4>
    {websites.map(renderPortfolioItem)}
    <h4 className="w-100 mb-3 mt-4">Strony z zintegrowanym modułem do zamówień online</h4>
    {iframes.map(renderPortfolioItem)}
    <Modal isOpen={!!activePhoto} toggle={() => setActivePhoto(null)} className="portfolio-modal">
      {!!activePhoto && <ModalBody>
        <img src={activePhoto.src} alt={`Strona restauracji ${activePhoto.name} z modułem do zamówień online`} className="w-100" />
      </ModalBody>}
    </Modal>
  </section>;
};

export default WebsitePortfolio;